import React, { useEffect, useState } from 'react'
import { Check, AlertCircle } from 'lucide-react'

export type ToastVariant = 'success' | 'error'
interface ToastItem { id: number; message: string; variant: ToastVariant }

type Listener = (items: ToastItem[]) => void

let items: ToastItem[] = []
let seq = 0
const listeners = new Set<Listener>()
const emit = () => listeners.forEach((l) => l([...items]))

/** Push a toast from anywhere (incl. non-React code such as fetchData). */
export function pushToast(message: string, variant: ToastVariant = 'success') {
  const id = ++seq
  items = [...items, { id, message, variant }]
  emit()
  setTimeout(() => {
    items = items.filter((t) => t.id !== id)
    emit()
  }, 2200)
}

/** Hook returning a stable toast() helper. */
export function useToast() {
  return { toast: pushToast }
}

export const ToastHost: React.FC = () => {
  const [list, setList] = useState<ToastItem[]>(items)
  useEffect(() => {
    listeners.add(setList)
    return () => { listeners.delete(setList) }
  }, [])

  if (list.length === 0) return null
  return (
    <div className="toast-host" role="status" aria-live="polite">
      {list.map((t) => (
        <div key={t.id} className={`toast ${t.variant === 'error' ? 'toast--error' : ''}`.trim()}>
          <span className="toast__icon">{t.variant === 'error' ? <AlertCircle /> : <Check />}</span>
          {t.message}
        </div>
      ))}
    </div>
  )
}
